import React from "react";
import { useSelector } from "react-redux";
import { Wrapper, Card, Title } from "app/NativeComponents/common";
import PlanModule from "./PlanModule";

const PlanModules = props => {
  const { user } = useSelector(({ auth }) => auth);
  const { platform } = useSelector(({ native }) => native);
  const {
    plan_modules,
    loading_lead_limits,
    current_lead_limit,
    driving_lead_limit,
    total_lead_count,
    current_billing_cycle_driving_lead_count,
    loading_list_lead_limits,
    list_lead_limit,
    current_billing_cycle_list_lead_count,
    loading_conversation_limits,
    conversation_limit,
    current_billing_cycle_conversation_count
  } = useSelector(({ billing }) => billing);
  const { colors } = useSelector(({ settings }) => settings);
  if (user.team_clearance_level > 0 || user.team_owner == 1) {
    return (
      <Wrapper>
        <Wrapper style={{ padding: 20 }}>
          <Title>Products & Services: </Title>
        </Wrapper>
        <Card>
          <PlanModule
            title={"DealMachine Managed Leads"}
            slug={"crm"}
            show_limits={true}
            loading={loading_lead_limits}
            current_limit={current_lead_limit}
            current_count={total_lead_count}
            limit_title={"Manage Leads"}
            //{...props, user, plan_modules}
            {...{ ...props, user, plan_modules, colors, platform }}
          />
          <PlanModule
            title={"DealMachine Street Engine"}
            slug={"driving"}
            show_limits={true}
            loading={loading_lead_limits}
            current_limit={driving_lead_limit}
            current_count={current_billing_cycle_driving_lead_count}
            limit_title={"Leads per month"}
            //{...props, user, plan_modules}
            {...{ ...props, user, plan_modules, colors, platform }}
          />
          <PlanModule
            title={"DealMachine List Engine"}
            slug={"lists"}
            show_limits={true}
            loading={loading_list_lead_limits}
            current_limit={list_lead_limit}
            current_count={current_billing_cycle_list_lead_count}
            limit_title={"Leads per month"}
            {...{ ...props, user, plan_modules, colors, platform }}
          />
          <PlanModule
            title={"DealMachine Message Engine"}
            slug={"messages"}
            show_limits={true}
            loading={loading_conversation_limits}
            current_limit={conversation_limit}
            current_count={current_billing_cycle_conversation_count}
            limit_title={"Active Conversations"}
            {...{ ...props, user, plan_modules, colors, platform }}
          />
        </Card>
      </Wrapper>
    );
  }

  return <Wrapper />;
};

export default PlanModules;
